import { Chip } from '@mui/material';
import type { ComplaintCategory, ComplaintStatus } from '../../lib/complaints-api';
import { useT } from '../../i18n';

const STATUS_COLORS: Record<ComplaintStatus, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
  NEW: 'info',
  IN_PROGRESS: 'warning',
  RESOLVED: 'success',
  CANCELLED: 'default',
};

// status -> i18n key (shared by the complaints list / show pages).
export const COMPLAINT_STATUS_KEY: Record<ComplaintStatus, string> = {
  NEW: 'comp.statusNew',
  IN_PROGRESS: 'comp.statusInProgress',
  RESOLVED: 'comp.statusResolved',
  CANCELLED: 'comp.statusCancelled',
};

export function ComplaintStatusChip({ status }: { status: ComplaintStatus }) {
  const t = useT();
  return (
    <Chip
      label={t(COMPLAINT_STATUS_KEY[status] ?? status)}
      color={STATUS_COLORS[status] ?? 'default'}
      size="small"
    />
  );
}

// category -> i18n key (shared by the complaints list / show pages).
export const COMPLAINT_CATEGORY_KEY: Record<ComplaintCategory, string> = {
  FACILITY_DAMAGE: 'comp.catFacilityDamage',
  CLEANLINESS: 'comp.catCleanliness',
  NOISE: 'comp.catNoise',
  LIGHTING: 'comp.catLighting',
  SECURITY: 'comp.catSecurity',
  OTHER: 'comp.catOther',
};

export function ComplaintCategoryChip({ category }: { category: ComplaintCategory }) {
  const t = useT();
  return (
    <Chip
      label={t(COMPLAINT_CATEGORY_KEY[category] ?? category)}
      size="small"
      variant="outlined"
    />
  );
}
